import { Component, Input } from '@angular/core';
import { StepperBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-stepper',
  templateUrl: './mr-stepper.component.html',
  styleUrls: ['./mr-stepper.component.scss'],
})
export class MrStepperComponent extends MessageBlockBaseDirective {
  @Input() block!: StepperBlock;

  /** [0, 1, ..., n-1] — for rendering N dots in the template. */
  range = (n: number): number[] => Array.from({ length: Math.max(0, n) }, (_, i) => i);
}
